import classNames from 'classnames';
import { noop } from 'lodash-es';
import { createContext, useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SimpleConfirmDialog } from '../components/dialogs/SimpleConfirmDialog';
import { externalLinks } from '../config/externalLinks';
import { formatError } from '../utils/errorUtils';
import { useAuthEnvelopeStyles } from './AuthEnvelope.styles';
import { useAuthErrorDialogStyles } from './AuthErrorDialog.styles';

export function AuthEnvelopeTitle({ text, textId, className }) {
  const { styles } = useAuthEnvelopeStyles();
  return (
    <h3 className={classNames(styles.title, className)}>
      {textId ? <FormattedMessage id={textId} /> : text}
    </h3>
  );
}

export function AuthEnvelopeSubtitle({ text, textId }) {
  const { styles } = useAuthEnvelopeStyles();
  return (
    <h3 className={styles.subtitle}>
      {textId ? <FormattedMessage id={textId} /> : text}
    </h3>
  );
}

export function AuthEnvelopeInfoText({ text, textId }) {
  const { styles } = useAuthEnvelopeStyles();
  return (
    <h4 className={styles.infoText}>
      {textId ? <FormattedMessage id={textId} /> : text}
    </h4>
  );
}

export function AuthEnvelopeLinks({ children }) {
  const { styles } = useAuthEnvelopeStyles();
  return <div className={styles.links}>{children}</div>;
}

const AuthErrorContext = createContext({ errorMessage: noop });

export function useAuthErrorMessage() {
  return useContext(AuthErrorContext).errorMessage;
}

function AuthErrorDialog({ error, close }) {
  const intl = useIntl();
  const { styles } = useAuthErrorDialogStyles();

  if (!error) {
    return null;
  }
  return (
    <SimpleConfirmDialog
      className={styles.authErrorDialog}
      data-subject="auth"
      data-role="error-dialog"
      text={formatError(error, { intl })}
      cancelTextId="buttons.dismiss"
      onClose={close}
      {...error.dialogProps}
    >
      <div className={styles.links}>
        <a href={externalLinks.helpDesk} target="__blank">
          <FormattedMessage id="auth.errorDialog.needHelp" />
        </a>
        <br />
        <a href={externalLinks.contact} target="__blank">
          <FormattedMessage id="auth.errorDialog.contact" />
        </a>
      </div>
    </SimpleConfirmDialog>
  );
}

export function AuthEnvelope({ className, ...rest }) {
  const { styles } = useAuthEnvelopeStyles();
  const [error, setError] = useState();

  return (
    <AuthErrorContext.Provider value={{ errorMessage: setError }}>
      <AuthErrorDialog error={error} close={() => setError(undefined)} />
      <div className={classNames(styles.authEnvelope, className)} {...rest} />
    </AuthErrorContext.Provider>
  );
}
